<template>
    <div class="wrapper-change-avatar">
        <div class="wrapper-avatar">
            <img :src="srcAvatar" class="img-avatar" :class="checkDefaultImage()">
            <input type="file" ref="fileAvatar" name="file_avatar" id="file_avatar" @change="previewFiles()" accept="image/x-png,image/jpeg" style="display:none;">
        </div>
        <div class="px-4">
            <label for="file_avatar" class="btn btn-primary btn-lg btn-block" :disabled="isImageLoading">เปลี่ยนรูปโปรไฟล์</label>
            <a :href="getUrl('member/home')" class="btn btn-light btn-lg btn-block">ย้อนกลับ</a>
        </div>
    </div>
</template>

<script>
import PathAvatarDefault from '../../../../assets/img/avatar.png';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

export default {
    data: () => ({
        isProcessing: false,
        srcAvatar: '',
        isImageLoading: false,
        loader: null,
    }),
    props: {
        baseUrl: '',
        oldAvatarPath: '',
    },
    async created () {
        if (this.oldAvatarPath) {
            this.srcAvatar = this.normalizeUrl(this.oldAvatarPath);
        } else {
            this.srcAvatar = PathAvatarDefault;
        }
    },
    methods: {
        showLoading() {
            this.loader = this.$loading.show({
                canCancel: false,
            });
            this.isImageLoading = true;
        },
        hideLoading() {
            if (this.loader != null) {
                this.loader.hide();
            }
            this.isImageLoading = false;
        },
        getUrl(pathName) {
            return `${this.baseUrl}/${pathName}`;
        },
        normalizeUrl(pathName) {
            if (!pathName) {
                return PathAvatarDefault;
            }

            if (/^https?:\/\//i.test(pathName)) {
                return pathName;
            }

            return this.getUrl(pathName);
        },
        checkDefaultImage() {
            return this.srcAvatar == PathAvatarDefault ? 'default-image' : '';
        },
        previewFiles() {
            if (this.isImageLoading) {
                return;
            }
            var vm = this;
            var files = event.target.files;
            if (files && files[0]) {
                if (files[0].type != 'image/png' && files[0].type != 'image/jpeg') {
                    // window.alertbox('only jpg/jpeg file types are allowed', 'warning');
                    alert('only jpg/jpeg file types are allowed', 'warning');
                    this.resetImage();
                    return;
                }
                var fileSize = files[0].size;
                var mbMaxSize = 25 * (1024 * 1024);  // 25 MB
                if (fileSize > mbMaxSize) {
                    // window.alertbox('Maximum allowed 25MB for uploaded files', 'warning');
                    alert('Maximum allowed 25MB for uploaded files', 'warning');
                    this.resetImage();
                    return;
                }
                vm.showLoading();
                vm.uploadAvatar().then(() => {
                    vm.hideLoading();
                });
            }
        },
        resetImage() {
            this.$refs.fileAvatar.value = '';
            this.srcAvatar = PathAvatarDefault;
        },
        uploadAvatar() {
            const vm = this;
            axios.defaults.headers.common["X-CSRF-TOKEN"] = document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content");

            var formData = new FormData();
            formData.append('fileAvatar', this.$refs.fileAvatar.files[0]);

            return axios.post(this.getUrl('/member/api/change-avatar'),
                formData
            ).then(({ data }) => {
                if (data != null) {
                    if (data.success) {
                        vm.srcAvatar = data.avatarFullPath;
                        setTimeout(() => {
                            alert('เปลี่ยนรูปเรียบร้อย');
                            window.location = this.getUrl('member/home');
                        }, 500);
                    } else {
                        alert("Something Error!");
                    }
                }
            }).catch(err => {
                console.log('error : ', err);
            });
        },
    }
}
</script>

<style lang="scss" scoped>
    .img-avatar {
        display: block;
        margin: 1.5em auto 0;
        max-width: 300px;
        height: 300px;
        &.default-image {
            border-radius: 50%;
        }
    }
    label[disabled] {
        opacity: 0.5;
    }
</style>
